import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/**
 * 근무일정 팝업 안에서 쓰는 근무코드 목록 — 병원별로 기억한다.
 *
 * 서버 근무코드에 더해 'custom'(커스텀 시간)과 'basic'(기본 직원) 두 칸을 항상 붙인다.
 * 이미 기억해 둔 선택 여부가 있으면 그것이 이긴다.
 */
export type StoredWorkStateCode = {
    _id: string
    isSelected: boolean
    [extra: string]: unknown
}

export type V2WorkCodeWithinWorkStateState = {
    hospitals: Record<string, StoredWorkStateCode[] | undefined>
}

const state: V2WorkCodeWithinWorkStateState = {
    hospitals: {},
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'AC_V2WorkCodeWithinWorkState_Set': (store: Store, param: unknown): void => {
        store.commit('MU_V2WorkCodeWithinWorkState_Set', param)
    },
    'AC_V2WorkCodeWithinWorkState_Update': (store: Store, param: unknown): void => {
        store.commit('MU_V2WorkCodeWithinWorkState_Update', param)
    },
}

const mutations = {
    'MU_V2WorkCodeWithinWorkState_Set': (
        state: V2WorkCodeWithinWorkStateState,
        param: { hospitalID: string; workCodes: { _id: string }[] },
    ): void => {
        const hospitalID = param.hospitalID
        const origins = state.hospitals[hospitalID] ?? []
        const codes: StoredWorkStateCode[] = param.workCodes.map((item) => ({
            ...item,
            isSelected: origins.find((c) => c._id == item._id)?.isSelected ?? true,
        }))
        codes.push({ _id: 'custom', isSelected: origins.find((c) => c._id == 'custom')?.isSelected ?? true })
        codes.push({ _id: 'basic', isSelected: origins.find((c) => c._id == 'basic')?.isSelected ?? false })
        state.hospitals[hospitalID] = codes
    },
    /** 하나를 눌러 뒤집는다. 목록에 없으면 아무 일도 하지 않는다 */
    'MU_V2WorkCodeWithinWorkState_Update': (
        state: V2WorkCodeWithinWorkStateState,
        param: { hospitalID: string; workCode: { _id: string } },
    ): void => {
        const origins = state.hospitals[param.hospitalID] ?? []
        const index = origins.findIndex((c) => c._id == param.workCode._id)
        if (index != -1) {
            origins[index].isSelected = !origins[index].isSelected
        }
    },
}

const V2WorkCodeWithinWorkState: Module<V2WorkCodeWithinWorkStateState, StoreState> = { state, actions, mutations }

export default V2WorkCodeWithinWorkState
